/* Global imports. */
import React from "react";

interface Props {
  imageUrl: string;
  imageLinkURL?: string;
  componentID?: string;
}

function BannerImage({imageUrl, imageLinkURL, componentID}: Props) {
  
  return imageLinkURL ? (
    <a href={imageLinkURL}>
      <img id={componentID} data-component="banner" src={imageUrl} alt="" className="w-full" />
    </a>
  ) : (
    <img id={componentID} data-component="banner" src={imageUrl} alt="" className="w-full" />
  );
} 

export default BannerImage;
